// extracted by mini-css-extract-plugin
export var black = "_3g-6";
export var brand = "_3g-1";
export var ddefault = "_3g-0";
export var error = "_3g-3";
export var gray = "_3g-2";
export var highContrast = "_3g-8";
export var outline = "_3g-7";
export var success = "_3g-5";
export var warning = "_3g-4";